export default __webpack_public_path__ + "static/media/resizeToSmall.5f0d01e1.svg";